import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{staticClass:"fill-height mt-16"},[_c(VCol,{attrs:{"cols":"12","align":"center"}},[_c('span',{staticClass:"text-h4 font-weight-light grey--text text--darken-2"},[_vm._v(" User Analytics ")]),_c('br'),_c('span',{staticClass:"text-h4 grey--text text--darken-2"},[_vm._v(" Coming Soon! ")])]),_c(VCol,{attrs:{"cols":"12","align":"center"}},[_c(VImg,{attrs:{"width":"50%","src":require("@/assets/comingSoon.svg")}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }